import * as React from 'react';
import cn from 'classnames';
import { HTMLAttributes, Ref, forwardRef } from 'react';
import '@mos-utils/css/lib/typography/EpicLead.css';

function EpicLead(
  { className, children, ...props }: HTMLAttributes<HTMLHeadingElement>,
  ref: Ref<HTMLHeadingElement>
) {
  return (
    <h1 ref={ref} className={cn('mos-epic-lead', className)} {...props}>
      {children}
    </h1>
  );
}

/**
 * @version ../package.json
 */
export default forwardRef(EpicLead);
